import {styled} from "@mui/material";

export const CustomTypeSection = styled('div')({
  marginBottom: 14,
});
